import { ModuleType } from './modules';

export interface SectionLayoutZone {
  installableModuleTypes: { moduleName: ModuleType; limit: number }[];
  installedModulesIds: number[];
  isInstallingModule?: boolean;
  currentlyInstalledModulePostion?: number;
}

export enum ZoneType {
  NONE = 'none',
  TOP_BAR = 'topBar',
  TOP_LEFT = 'topLeft',
  MID_LEFT = 'midLeft',
  BOTTOM_LEFT = 'bottomLeft',
  TOP_RIGHT = 'topRight',
  MID_RIGHT = 'midRight',
  BOTTOM_RIGHT = 'bottomRight',
}

export interface SectionLayoutZones {
  topBar?: SectionLayoutZone;
  topLeft?: SectionLayoutZone;
  midLeft?: SectionLayoutZone;
  bottomLeft?: SectionLayoutZone;
  topRight?: SectionLayoutZone;
  midRight?: SectionLayoutZone;
  bottomRight?: SectionLayoutZone;
}

export interface SectionLayout {
  version: number;
  zones: SectionLayoutZones;
}

export interface Layout {
  [section: string]: SectionLayout;
}
